import api from './api';

export interface UserProfile {
    id: number;
    nome: string;
    email: string;
    role: string;
    avatar?: string;
}

export const authService = {
    getProfile: async () => {
        const response = await api.get<UserProfile>('/profile');
        return response.data;
    },
    updateProfile: async (data: Partial<UserProfile>) => {
        const response = await api.put<UserProfile>('/profile', data);
        return response.data;
    },
    uploadAvatar: async (file: File) => {
        const formData = new FormData();
        formData.append('avatar', file);
        const response = await api.post<{ avatarUrl: string }>('/profile/avatar', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }
};
